import { StyledDeliveryBox, StyledDeliveryBoxLeftContent, StyledDeliveryBoxRightContent } from './DeliveryBox.styles';
import React, { ForwardedRef, forwardRef, MouseEvent, ReactNode } from 'react';

interface Props {
  icon: ReactNode;
  children: ReactNode;
  active?: boolean;
  onClick?: (a?: MouseEvent<HTMLDivElement>) => void;
}

const DeliveryBox = forwardRef(
  ({ icon, children, active = false, onClick, ...props }: Props, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <StyledDeliveryBox
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => e.key === 'Enter' && onClick && onClick()}
        active={active}
        role="button"
        ref={ref}
        {...props}
      >
        {icon && <StyledDeliveryBoxLeftContent>{icon}</StyledDeliveryBoxLeftContent>}
        {children && <StyledDeliveryBoxRightContent>{children}</StyledDeliveryBoxRightContent>}
      </StyledDeliveryBox>
    );
  }
);
DeliveryBox.displayName = 'DeliveryBox';

export default DeliveryBox;
